module.exports = __webpack_public_path__ + "static/media/20201114_155742_712_IMG_0006.2e4250af.jpg";